import React from "react"
import MyImage from './../images/myimage.jpg'

const About = () => (
  <div className="row" id="about">
    <div className="about-container">
      <div className="button-look">
        <p>About me</p>
      </div>
      <div className="body-container">
        <div className="row">
          <div className="column col-md-6 align-middle">
            <img className="image-about" src={MyImage} alt="Chirag Jain" style={{width:"200px", borderRadius:"50%", zoom:"130%"}} />
          </div>
          <div className="column col-md-6 about-content">
            <h3 style={{color:"#fff",fontWeight:"bold"}}>Hi There</h3>
            <p>I'm the founder of Hungama Deal (Online Shopping Deals & Coupons Portal). I'm an Undergraduate Pre-Final Year Student currently undertaking a Bachelors course in Computer Science and Engineering at Swami Keshvanad Institute of Technology. I'm professional web developer and marketing specialist with extensive experience of Affiliate Marketing.</p>
            <div className="row">
              <div className="column row">
                <div className="row">
                <p><p style={{color:"red"}}>Name :</p> Chirag Jain</p>
                </div>
              </div>
              <div className="column row">
                <p><p style={{color:"red"}}>Phone Number :</p> +91 7597550171</p>
              </div>
            </div>
            <div className="row">
              <div className="column row">
                <p><p style={{color:"red"}}>Email :</p> me.chiragjain@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default About
